<div class="d-flex align-items-center flex-column py-5" *ngIf="switch">
  <div class="spinner-grow text-primary" role="status" style="width: 5rem; height: 5rem;">
    <span class="sr-only">Loading...</span>
  </div>
  <p class="mt-1 w700">
    Cargando...
  </p>
</div>